// extracted by mini-css-extract-plugin
export default {"body":"RouteDrawer_body__qeFA1","detailBody":"RouteDrawer_detailBody__Jn6DL"};